export const setPatient = (state, payload) => {
  state.patient = payload
}
export const setPatients = (state, payload) => {
  state.patients = payload
}
